import { render } from "./YhList.vue?vue&type=template&id=709f888f"
import script from "./YhList.vue?vue&type=script&lang=js"
export * from "./YhList.vue?vue&type=script&lang=js"

import "./YhList.vue?vue&type=style&index=0&id=709f888f&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__